var $37184f3a1eff2016$exports = {};
$37184f3a1eff2016$exports = {
    "clear": `\u{645}\u{633}\u{62D}`,
    "invalid": `(\u{63A}\u{64A}\u{631} \u{635}\u{627}\u{644}\u{62D})`,
    "loading": `\u{62C}\u{627}\u{631}\u{64D} \u{627}\u{644}\u{62A}\u{62D}\u{645}\u{64A}\u{644}...`,
    "noResults": `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{646}\u{62A}\u{627}\u{626}\u{62C}`,
    "valid": `(\u{635}\u{627}\u{644}\u{62D})`
};


export {$37184f3a1eff2016$exports as default};
//# sourceMappingURL=ar-AE.module.js.map
